const getExampleIntro = () => {
    return `
<FloatingTab 
    onOpen={() => {setFloatingTabOpen(floatingTabOpen);}}
    onClose={() => setFloatingTabOpen(!floatingTabOpen)}
    data={...}
/>
    `;
}

export default getExampleIntro;
